import React from 'react';
import Head from 'next/head';
import NavBar from '../components/navbar';
import Layout from '../components/layout';
import Container from '../components/container';
import Tabs from '../components/tabs';
import BronzenTable from '../components/bronzen-schild-table';
import GoudenSchildTable from '../components/gouden-schild-table';
import ZilverenSchildTable from '../components/zilveren-schild-table';
import PlayOffsWinnaarTable from '../components/play-offs-winnaar-table';
import BronzenStierTable from '../components/bronzen-stier-table';
import GoudenStierTable from '../components/gouden-stier-table';
import TopscorersTable from '../components/topscorers-table';
import TotaalTitels from '../components/totaal-titels';
import KampioenenTable from '../components/kampioenen-table';
import ClubStatsTable from '../components/clubs-table-stats';
import config from '../lib/config';

import { GetStaticProps } from 'next';
import { fetchAPI, getPrimaryMenuItems } from '../lib/api';
import { IMenuItem } from '../models/menu-item';
import { IPage } from '../models/page';
import { ISponsor } from '../models/sponsor';
import { H2 } from '../components/text';

// Todo: DEVP-140 responsize maken tab labels
// Todo: DEVP-238 Make collapsible component

interface IProps {
	primaryMenuItems: IMenuItem[];
	pageData: IPage;
	sponsors: ISponsor[];
}

export default function Statistieken({ primaryMenuItems, pageData: { page }, sponsors }: IProps) {
	const pageTitle = `${page.title} | ${config.siteName}`;
	const meta = page.seo?.description || page.title;

	const TABS = [
		{
			label: 'Bronzen schild',
			children: <BronzenTable results={page.historyStats} />,
		},
		{
			label: 'Zilveren schilden',
			children: <ZilverenSchildTable results={page.historyStats} />,
		},
		{
			label: 'Gouden schild',
			children: <GoudenSchildTable results={page.historyStats} />,
		},
		{
			label: 'Play Offs Winnaar',
			children: <PlayOffsWinnaarTable results={page.historyStats} />,
		},
		{ label: 'Bronzen stier', children: <BronzenStierTable /> },
		{ label: 'Gouden stier', children: <GoudenStierTable /> },
		{ label: 'Topscorers', children: <TopscorersTable /> },
		{ label: 'Totaal titels', children: <TotaalTitels /> },
		{ label: 'Kampioenen', children: <KampioenenTable /> },
		{ label: 'Clubs', children: <ClubStatsTable /> },
	];

	return (
		<Layout preview sponsors={sponsors} metaTitle={pageTitle} metaDesc={meta}>
			<Head>
				<title>{pageTitle}</title>
			</Head>
			<NavBar items={primaryMenuItems} />
			<Container className="py-12 xl:py-16">
				<article>
					<H2 className="text-center py-6">{page.title}</H2>
					<Tabs tabs={TABS} size={'sm'} tabColorInterted={false} selectedColor="red-500" />
				</article>
			</Container>
		</Layout>
	);
}

export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
	const primaryMenuItems = await getPrimaryMenuItems();

	const pageData = await fetchAPI<{ sponsors: { nodes: any[] }; page: { historyStats: any } }>(`
		query {
			page(id: 108868, idType: DATABASE_ID) {
				title
				content
				historyStats {
					goudenSchilden {
					  schilden {
						seizoensTitel
						seizoen {
						  periodeTitel
						  periode {
							club
							img {
							  altText
							  sourceUrl(size: MEDIUM)
							}
							naam
							titel
						  }
						}
					  }
					}
					bronzenSchilden {
					  schilden {
						seizoensTitel
						seizoen {
						  periodeTitel
						  periode {
							club
							img {
							  altText
							  sourceUrl(size: MEDIUM)
							}
							naam
							titel
						  }
						}
					  }
					}
					zilverenSchilden {
					  schilden {
						seizoensTitel
						seizoen {
						  periodeTitel
						  periode {
							club
							img {
							  altText
							  sourceUrl(size: MEDIUM)
							}
							naam
							titel
						  }
						}
					  }
					}
					playOffsWinnaar {
					  winnaars {
						seizoensTitel
						club {
						  naam
						  img {
							altText
							sourceUrl(size: MEDIUM)
						  }
						}
					  }
					}
				}
			}
			
			sponsors(first: 20) {
				nodes {
					title
					sponsor_fields {
						subtitle
						websiteUrl
						mainSponsor
						invertedImage {
							sourceUrl
						}
					}
				}
			}

		}
	`);

	return {
		revalidate: 300,
		props: {
			sponsors: pageData.sponsors.nodes,
			primaryMenuItems,
			pageData,
			preview,
			stats: pageData.page.historyStats,
		},
	};
};
